import { ProprieteAffichee } from "../proprieteAffichee";

export class Drilllog {
    id = 0;
    name = '';
    shortName = '';
    color = '#FFFFFF';
    regionId = 0;
    siteId?: number;
    isActive = true;

    getProprietesAffichees() {
        let tab: ProprieteAffichee[] = [];
        tab.push(new ProprieteAffichee('id', 'GLOBAL.IDENTIFICATEUR'));
        tab.push(new ProprieteAffichee('name', 'GLOBAL.NOM'));
        tab.push(new ProprieteAffichee('shortName', 'PRODUCTS.NAMESHORT'));
        tab.push(new ProprieteAffichee('color', 'PRODUCTS.TYPECOLOR'));
        return tab;
      }

  }